import React from 'react'

const KnowledgeCenter = () => {
  return (
    <div>KnowledgeCenter</div>
  )
}

export default KnowledgeCenter;